exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Gallery-local__fetching--2pmPf {\n  padding: 0 .25rem .5rem; }\n  .Gallery-local__fetching--2pmPf span {\n    height: 8rem;\n    background: #EEE;\n    border-radius: 5px;\n    margin-right: 1px;\n    width: 100%;\n    display: block; }\n\n.Gallery-local__notFound--68xrU {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  font-size: 1rem;\n  padding: 2rem 0; }\n  .Gallery-local__notFound--68xrU img {\n    height: 15rem;\n    margin-bottom: .5rem; }\n", ""]);

// exports
exports.locals = {
	"fetching": "Gallery-local__fetching--2pmPf",
	"notFound": "Gallery-local__notFound--68xrU"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/portal/portal/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src","node_modules/slick-carousel/slick"]}!./src/components/Community/Common/Gallery/Gallery.local.scss
// module id = 507
// module chunks = 0